var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QuestionAdornerViewModel } from "survey-creator-core";
import * as React from "react";
import { ReactElementFactory, ReactSurveyElementsWrapper } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
var CellQuestionDropdownAdornerComponent = /** @class */ (function (_super) {
    __extends(CellQuestionDropdownAdornerComponent, _super);
    function CellQuestionDropdownAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellQuestionDropdownAdornerComponent.prototype.createModel = function (props) {
        this.model = new QuestionAdornerViewModel(props.componentData, props.question, null);
    };
    CellQuestionDropdownAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "componentData"];
    };
    CellQuestionDropdownAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    CellQuestionDropdownAdornerComponent.prototype.render = function () {
        var question = this.props.question;
        var textStyle = this.props.question.textStyle;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-sv-drop-target-survey-element": this.model.element.name, className: "svc-question__adorner" },
                React.createElement("div", { className: " svc-question__content--in-popup svc-question__content" },
                    this.props.element,
                    React.createElement("div", { className: "svc-question__dropdown-choices" }, question.visibleChoices.map(function (item, index) { return (React.createElement("div", { className: "svc-question__dropdown-choice", key: "editable_choice_".concat(index) }, ReactSurveyElementsWrapper.wrapItemValue(question.survey, ReactElementFactory.Instance.createElement("survey-radiogroup-item", {
                        question: question,
                        cssClasses: question.cssClasses,
                        isDisplayMode: true,
                        item: item,
                        textStyle: textStyle,
                        index: index,
                        isChecked: question.value === item.value
                    }), question, item))); }))))));
    };
    return CellQuestionDropdownAdornerComponent;
}(CreatorModelElement));
export { CellQuestionDropdownAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-cell-dropdown-question", function (props) {
    return React.createElement(CellQuestionDropdownAdornerComponent, props);
});
